import PurgeEntitiesFromFlightTool from "./component";
export default PurgeEntitiesFromFlightTool;